<script setup lang="ts">
import { useCurrentUser } from 'vuefire'
import * as Sentry from '@sentry/vue'
import Auth from '@/layouts/auth.vue'
import AuthInfoState from '@/pages/auth/AuthInfoState.vue'
import { useViteEnvironment } from '@/composables/useViteEnvironment'
import { useBroadcastStore } from '@/stores/broadcast-store'

const authStore = useAuthStore()
const { authState } = storeToRefs(authStore)
const user = useCurrentUser()
const { isProd, isTest } = useViteEnvironment()

// we don't need this watcher on server
onMounted(() => {
  watch(user, (user, prevUser) => {
    if (user && !prevUser) {
      Sentry.setUser({ id: user.uid ?? undefined })
    }

    if (!user) {
      Sentry.setUser(null)
    }
  })
})

// Setup auth broadcast channel to sync auth state between tabs
useBroadcastStore()

const title = () => {
  if (isProd) {
    return 'Swipe4Work'
  }

  if (isTest) {
    return 'S4W - Test'
  }

  return 'S4W - Dev'
}

useHead({
  title,
  meta: [
    {
      content: 'Swipe4Work werkgeversportaal',
    },
  ],
})

const currentRoute = useRoute()

const showAuthOverlay = computed(() => {
  if (currentRoute.meta.layout === 'auth') {
    return false
  }

  return authState.value !== AuthState.Inactive
})
</script>

<template>
  <div v-if="showAuthOverlay">
    <Auth>
      <AuthInfoState />
    </Auth>
  </div>
  <template v-else>
    <suspense>
      <router-view />
    </suspense>
  </template>
  <DynamicDialog />
  <ConfirmDialog />
  <Toast position="bottom-right" />
</template>

<style lang="scss">
@use 'App.scss';
</style>
